(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cd-wear-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cd-fragrance-guides')) {
    customElements.define('cd-fragrance-guides', class extends HTMLElement {
      connectedCallback() {
        const media = this.closest('.product__media-wrapper');
        if (!media) return;
        const embedded = media.querySelector('.product__description .cd-wear-guide[data-cd-wear-guide]');
        if (embedded && !this.contains(embedded)) this.prepend(embedded);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
